import { Component } from '@angular/core';

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrl: './side-navigation-menu.component.scss'
})
export class SideNavigationMenuComponent {

}
